import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';
import { useSelector } from 'react-redux';
import {
	useLoadEntityWatcher,
	useLoadScheduleWatcher,
	useLoadMediaWatcher,
	useActions,
} from '@src/containers/ProfileVenue/hooks';

import VenueProfile from '@src/components/VenueProfile/connectors/default';
import ModalGiftBooking from '@src/components/ModalGiftBooking/connectors/default';
import ContactsModal from '@src/components/ContactsModal/connectors/standalone';
import { hooks as filterHooks } from '@src/containers/Filters';
import { selectors as profileSelectors } from '@src/containers/ProfileVenue';
import PackagesModal from '@src/components/PackagesModal/connectors/venueProfile';
import PanoramaModal from '@src/components/ModalPanorama/connectors/default';
import ModalFavorite from '@src/components/ModalFavorite/connectors/default';
import MediaPreview from '@src/components/MediaPreview/connectors/venue';
import { FAVOURED_ENTITY_TYPES } from '@src/containers/Favourites/constants';
import ModalPhotoCoverCVenue from '@src/components/ModalPhotoCover/connectors/venue';
import { getMediaPack } from '@src/containers/ProfileVendor/selectors/getMediaPack';
import ModalQuickInqCDefault from '@src/components/ModalQuickInq/connectors/default';
import ModalQuickStatusCInquire from '@src/components/ModalQuickStatus/connectors/inquire';

const useHooks = () => {
	const { loadEntityWatcher } = useLoadEntityWatcher();
	const { loadScheduleWatcher } = useLoadScheduleWatcher();
	const { loadMediaWatcher } = useLoadMediaWatcher();
	const { resetState } = useActions();
	const { resetState: resetFilter } = filterHooks.useActions();
	const profileId = useSelector(profileSelectors.profileIdSelector);

	useEffect(() => {
		return () => {
			resetState();
			resetFilter();
		};
	}, [resetState, resetFilter]);

	useUpdateEffect(() => {
		loadEntityWatcher();
	}, [loadEntityWatcher]);

	useUpdateEffect(() => {
		loadScheduleWatcher();
	}, [loadScheduleWatcher]);

	useUpdateEffect(() => {
		loadMediaWatcher();
	}, [loadMediaWatcher]);

	return { profileId };
};

export const VenueProfilePage = () => {
	const { profileId } = useHooks();
	const mediaPack = useSelector(getMediaPack);

	return (
		<>
			<div className="region-content">
				<VenueProfile />
				<ContactsModal />
			</div>
			<div className="rgn-mdl">
				<PackagesModal />
				<PanoramaModal />
				<MediaPreview fullscreen />
				<ModalFavorite
					type={FAVOURED_ENTITY_TYPES.RESTAURANTS}
					id={profileId}
				/>
				<ModalQuickInqCDefault pageType="profile" />
				<ModalQuickStatusCInquire />
				{mediaPack && <ModalPhotoCoverCVenue />}
			</div>
			<div className="rgn-mdl-gift">
				<ModalGiftBooking />
			</div>
		</>
	);
};

// Legacy connector to old router
export const VenueProfilePageLegacy = withRouter((props) => {
	// eslint-disable-next-line react/prop-types
	const { location, history } = props;
	const { paramsUpdateWatcher, urlUpdateWatcher } = filterHooks.useUrlHooks();

	useUpdateEffect(() => {
		paramsUpdateWatcher({ location, ignoreProps: ['date'] });
	}, [location]);

	useUpdateEffect(() => {
		urlUpdateWatcher({
			history,
			isNoFriendlyUrls: true,
			ignoreProps: ['date'],
		});
	}, [urlUpdateWatcher]);

	return <VenueProfilePage />;
});

export default VenueProfilePage;
